import { PropertyValue } from '@affine/component';
import { DocService } from '@affine/core/modules/doc';
import { isDocCreationLocation } from '@affine/core/modules/doc-location/capture';
import { i18nTime, useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';

export const CreatedLocationValue = () => {
  const t = useI18n();
  const record = useService(DocService).doc.record;
  const location = useLiveData(record.createdLocation$);
  if (!isDocCreationLocation(location)) return null;

  return (
    <PropertyValue readonly data-testid="created-location-row">
      <div
        style={{
          minWidth: 0,
          overflowWrap: 'anywhere',
          whiteSpace: 'normal',
        }}
      >
        {location.placeName ? <div>{location.placeName}</div> : null}
        <div>
          {location.latitude.toFixed(5)}, {location.longitude.toFixed(5)}
          {' · ±'}
          {Math.ceil(location.accuracy)} m
        </div>
        <div>
          {location.source === 'update'
            ? t['com.affine.doc-info.location-captured-on-update']()
            : t['com.affine.doc-info.location-captured']()}
          {' · '}
          <time dateTime={new Date(location.capturedAt).toISOString()}>
            {i18nTime(location.capturedAt, {
              absolute: { accuracy: 'minute' },
            })}
          </time>
        </div>
      </div>
    </PropertyValue>
  );
};
